export default function disableRestrictedForm() {
  $("form.disabled")
    .find("input, textarea, button, select")
    .attr("disabled", "disabled")
}
